export default {
  'pages:subscription-confirmation:page-title': 'Aanmelding bevestigen',
  'pages:subscription-confirmation:header': 'Wacht even een momentje...',
};
